import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { JhiEventManager } from 'ng-jhipster';
import { LoginService } from './login.service';
import { StateStorageService } from '../../shared/services/state-storage.service';
import { Router } from '@angular/router';
import {TrackingService} from '../../shared/services/tracking.service';
import {TrackingAction, TrackingCategory} from '../../shared/model/tracking/tracking.enum';

@Component({
    selector: 'jhi-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: [
        'authentication.component.scss'
    ]
})
export class AuthenticationComponent implements AfterViewInit {

    @ViewChild('email') emailInputElement: ElementRef;

    showPassword = false;
    authenticationError: boolean;
    username: string;
    password: string;
    rememberMe: boolean;
    credentials: any;
    isSigning: boolean;

    constructor(private eventManager: JhiEventManager ,
                private loginService: LoginService,
                private stateStorageService: StateStorageService,
                private router: Router,
                private trackingService: TrackingService) {
        this.credentials = {};
    }

    ngAfterViewInit() {
        /* this.emailInputElement.nativeElement.focus(); */
    }


    login() {
        this.isSigning = true;
        this.trackRememberMe(this.rememberMe ? TrackingAction.OPTION_ACTIVATED : TrackingAction.OPTION_NOT_ACTIVATED);
        this.loginService.login({
            username: this.username,
            password: this.password,
            rememberMe: this.rememberMe
        }).then(() => {
            this.successLogin();
            this.trackLogin(TrackingAction.SUCCESS);
        }).catch(() => {
            this.isSigning = false;
            this.authenticationError = true;
            this.trackLogin(TrackingAction.FAILED);
        });
    }

    resetAuthErrors() {
        this.authenticationError = false;
    }

    successLogin() {
        this.authenticationError = false;

        this.eventManager.broadcast({
            name: 'authenticationSuccess',
            content: 'Sending Authentication Success'
        });

        let previousState = this.stateStorageService.getPreviousState();
        if (previousState && typeof previousState === 'string') {
            this.stateStorageService.resetPreviousState();
            this.router.navigate([previousState]);
        } else {
            this.router.navigate(['accueil']);
        }
    }

    private trackLogin(action: TrackingAction) {
        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.AUTHENTICATION,
                name: 'Connexion'
            }
        });
    }

    private trackRememberMe(action: TrackingAction) {
        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.AUTHENTICATION,
                name: 'Rester connecté'
            }
        });
    }

    public togglePassword($event: any) {
      this.showPassword = !this.showPassword;
      $event.preventDefault();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/authentication/authentication.component.ts